enum ElementType {
    Air = "Air",
    Dark = "Dark",
    Earth = "Earth",
    Fire = "Fire",
    Ice = "Ice",
    Light = "Light"
}
